/** The × on one added offer. */
export function DismissAdd({ merchant, onClick }: { merchant: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Dismiss ${merchant}`}
      className="h-8 w-8 shrink-0 rounded-lg text-lg leading-none text-neutral-500 hover:bg-white/5 hover:text-neutral-200"
    >
      ×
    </button>
  );
}
